













































































































































import { Vue, Component } from 'vue-property-decorator'
import { mapActions } from 'vuex'
import { onError } from '@/libs/errorLib'
import orgemails from '@/libs/orgEmails'
import i18n from './../i18n'
import Vuetify from 'vuetify/lib'

// register the beforeRouteLeave hook
Component.registerHooks(['beforeRouteLeave'])

  @Component({
    methods: {
      ...mapActions('Referrals', ['submitReferral'])
    }
  })
export default class ReferralForm extends Vue {
    submitReferral!: (referral: {}) => void // from the mapActions above
    clientname = ''
    clientphone = ''
    clientnote = ''
    clientbirth = ''
    clientgender = ''
    clientlocation = ''
    clientphoto = null
    clientlat: number | null = null
    clientlon: number | null = null
    org = null

    dobmenu = false
    valid= false
    loading= false
    saved = false

    nameRules = [
      (v: string) => !!v || i18n.t('referralForm.nameRule')
    ]

    phoneRules = [
      (v: string) => !!v || i18n.t('referralForm.phoneRule')
    ]

    orgemailRules = [
      (v: string) => !!v || i18n.t('referralForm.orgemailRule')
    ]

    // the whitelisted set of orgemails
    // loaded from @/libs/orgEmails
    orgemails = orgemails

    genders = [
      this.$t('referralForm.male'),
      this.$t('referralForm.female'),
      this.$t('referralForm.other'),
      this.$t('referralForm.unknown'),
      this.$t('referralForm.prefer_not_to_say')
    ]

    locations = [
      this.$t('referralForm.home'),
      this.$t('referralForm.school'),
      this.$t('referralForm.work'),
      this.$t('referralForm.family_member'),
      this.$t('referralForm.friend'),
      this.$t('referralForm.commune_village')
    ]

     items = ['Foo', 'Bar', 'Fizz', 'Buzz']
     created () {
       this.getCurrentPosition()
     }

     async getCurrentPosition () {
       const options = {
         enableHighAccuracy: true,
         timeout: 5000
       }
       if (navigator.geolocation) {
         navigator.geolocation.getCurrentPosition(position => {
           const { latitude, longitude } = position.coords
           this.clientlat = latitude
           this.clientlon = longitude
         }, err => {
           onError(err)
         }, options)
       }
     }

     beforeRouteLeave (to: any, from: any, next: any) {
       if (!this.saved) {
         this.showDialog()
           .then(next)
           .catch(() => next(false))
       } else {
         next()
       }
     }

     showDialog () {
       return (this as any).$dialog.confirm(this.$t('referralForm.confirmLeavePage'), { cancelText: this.$t('referralForm.button'), okText: this.$t('referralForm.buttonContinue') })
     }

     setImage (file: any) {
       this.clientphoto = file
     }

     async submit () {
       if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
         this.loading = true
         const { clientname, clientphone, clientphoto, clientnote, clientbirth, clientgender, clientlocation, clientlat, clientlon, org } = this
         this.saved = true
         await this.submitReferral({ clientname, clientphone, clientphoto, clientnote, clientbirth, clientgender, clientlocation, clientlat, clientlon, org })
         this.loading = false
       }
     }
}
